module.exports = __webpack_public_path__ + "img/20200621_095723.19508c27.jpg";